import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

type StandardTrialsUserAndStorageLimitBreakersExperimentEligibility = {
	context: EditionAwarenessContextType;
};

export function isEligibleForStandardTrialsUserAndStorageLimitBreakers({
	context,
}: StandardTrialsUserAndStorageLimitBreakersExperimentEligibility): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		isInvoiceable,
		licensedUsers,
		canAddPaymentDetails,
		trialDaysLeft,
		storageUsageInGB,
	} = context;

	const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
	const isOverUserLimit = !!(licensedUsers && licensedUsers > 10);
	const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);

	if (
		product === 'confluence' &&
		edition === 'standard' &&
		fg('connie_edition_awareness_standard_trials_gate')
	) {
		return !!(
			(isInTrial || isInPredunning) &&
			isInvoiceable === false &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	if (
		product === 'jira' &&
		edition === 'standard' &&
		fg('jira_edition_awareness_standard_trials_gate')
	) {
		return !!(
			isInTrial &&
			isInvoiceable === false &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	return false;
}
